module.exports = {"title":"Home","layout":"home","path":"/","body":""}


// WEBPACK FOOTER //
// ../~/gatsby/dist/loaders/markdown-loader?{"config":{"siteTitle":"Coriolan UI","siteDescr":"sass mixins pack","siteAuthor":"","siteNpmUrl":"https:/www.npmjs.com/package/coriolan-ui","siteGithubUrl":"https:/github.com/coriolan-ui/coriolan-ui.github.io","linkPrefix":""},"shouldPrefix":true}!./pages/index.md